// hero slideshow
// var sliderElement = document.querySelector(".js-slideshow-hero")

// var heroSlider = new KeenSlider(sliderElement, {
//   loop: true,
//   duration: 1000,
//   dragStart: () => {
//     autoplay(false)
//   },
//   dragEnd: () => {
//     autoplay(true, heroSlider)
//   },
// })

// sliderElement.addEventListener("mouseover", () => {
//   autoplay(false)
// })
// sliderElement.addEventListener("mouseout", () => {
//   autoplay(true, heroSlider)
// })
// autoplay(true, heroSlider)

// var contentSliderElement = document.querySelector(".js-slideshow-content")
// var intervalC = 0
// function autoplayC(run, sliderInstance) {
//   clearInterval(intervalC)
//   interval = setInterval(() => {
//     if (run && sliderInstance) {
//       sliderInstance.next()
//     }
//   }, 4000)
// }

// var contentSlider = new KeenSlider(contentSliderElement, {
//   loop: true,
//   created: function (instance) {
//     document
//       .getElementById("js-arrow-prev")
//       .addEventListener("click", function () {
//         instance.prev()
//       })

//     document
//       .getElementById("js-arrow-next")
//       .addEventListener("click", function () {
//         instance.next()
//       })
//     var dots_wrapper = document.getElementById("js-dots")
//     var slides = document.querySelectorAll(".js-slide")
//     slides.forEach(function (t, idx) {
//       var dot = document.createElement("button")
//       dot.classList.add("c-dot")
//       dots_wrapper.appendChild(dot)
//       dot.addEventListener("click", function () {
//         instance.moveToSlide(idx)
//       })
//     })
//     updateClasses(instance)
//   },
//   slideChanged(instance) {
//     updateClasses(instance)
//   },
// })

// contentSliderElement.addEventListener("mouseover", () => {
//   autoplayC(false)
// })
// contentSliderElement.addEventListener("mouseout", () => {
//   autoplayC(true, contentSlider)
// })
// autoplayC(true, contentSlider)

var duration = 4000 // default
var allSliders = document.querySelectorAll(".c-slideshow").forEach(slider => {
  var dataSlider = null
  if(slider.dataset.slider){
    var dataSlider = JSON.parse(slider.dataset.slider)
    if(dataSlider.duration) duration = dataSlider.duration
  }

  var interval = 0
  function autoplay(run, instance) {
    clearInterval(interval)
    console.log("instamce", instance)
    interval = setInterval(() => {
      if (run && instance) {
        instance.next()
      }
    }, duration)
  }

  let extraData = {
    created: function (instance) {
      if(dataSlider.arrows) {
        if(document.getElementById("js-arrow-prev")){
          document.getElementById("js-arrow-prev")
            .addEventListener("click", function () {
                instance.prev()    
            })
        }
        if(document.getElementById("js-arrow-next")){
          document.getElementById("js-arrow-next")
            .addEventListener("click", function () {
                instance.next()
            })
        }
      }
      
      if(dataSlider.dots) {
        let dots_wrapper = document.getElementById("js-dots")      
        if(dots_wrapper){
          let slides = slider.querySelectorAll(".js-slide")
          slides.forEach(function (t, idx) {
            let dot = document.createElement("button")
            let dot_span = document.createElement("span")
            dot.classList.add("c-dot")
            dot.appendChild(dot_span)
            dots_wrapper.appendChild(dot)
            dot.addEventListener("click", function () {
              instance.moveToSlide(idx)
            })
          })
          updateClasses(instance, slider)
        }
      }
    },
    slideChanged(instance) {
      if(dataSlider.dots) {
        updateClasses(instance, slider)
      }
    }
  }

  // dataSlider = dataSlider;
  dataSlider = {...dataSlider, ...extraData }

  let autoPlayData = {
    dragStart: (e) => {
        autoplay(false)
    },
    dragEnd: (e) => {
        autoplay(true, sliderElement)
    }
  }

  if(dataSlider.autoplay){
    dataSlider = {...dataSlider, ...extraData, ...autoPlayData }
  }

  var sliderElement = new KeenSlider(slider, dataSlider)

  if(dataSlider.autoplay){
    autoplay(true, sliderElement)

    slider.addEventListener("mouseover", () => {
      autoplay(false)
    })
    slider.addEventListener("mouseout", () => {
      autoplay(true, sliderElement)
    }) 
    autoplay(true, sliderElement)
  }
})

function updateClasses(instance, slider) {
  var slide = instance.details().relativeSlide
  // var arrowLeft = document.getElementById("js-arrow-prev")
  // var arrowRight = document.getElementById("js-arrow-next")
  // slide === 0
  //   ? arrowLeft.classList.add("c-arrow--disabled")
  //   : arrowLeft.classList.remove("c-arrow--disabled")
  // slide === instance.details().size - 1
  //   ? arrowRight.classList.add("c-arrow--disabled")
  //   : arrowRight.classList.remove("c-arrow--disabled")

  if(slider.dataset.slider){
    var dataSlider = JSON.parse(slider.dataset.slider)
    if (dataSlider.duration) duration = dataSlider.duration 
  }

  var dots = document.querySelectorAll(".c-dot").forEach((dot, idx) => {
    let dot_span = dot.querySelector("span")
    
    if(idx === slide) {
      dot.classList.add("c-dot--active")
      dot_span.animate({ width: '100%' }, duration)
    }
    else {
      dot.classList.remove("c-dot--active")
      dot_span.style.width = 0
    }
  })
}